module.exports = __webpack_public_path__ + "img/microcaps.12a16e10.svg";